import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type CartItemCountQueryVariables = Types.Exact<{
  eventId: Types.Scalars['String'];
}>;

export type CartItemCountQuery = { __typename?: 'Query'; stationeryCartByEvent: Array<{ __typename?: 'StationeryCartItem'; orderNumber: string }> };

export const CartItemCountDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CartItemCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'stationeryCartByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useCartItemCountQuery__
 *
 * To run a query within a React component, call `useCartItemCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCartItemCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCartItemCountQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useCartItemCountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CartItemCountQuery, CartItemCountQueryVariables>) {
  return ApolloReactHooks.useQuery<CartItemCountQuery, CartItemCountQueryVariables>(CartItemCountDocument, baseOptions);
}
export function useCartItemCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CartItemCountQuery, CartItemCountQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<CartItemCountQuery, CartItemCountQueryVariables>(CartItemCountDocument, baseOptions);
}
export type CartItemCountQueryHookResult = ReturnType<typeof useCartItemCountQuery>;
export type CartItemCountLazyQueryHookResult = ReturnType<typeof useCartItemCountLazyQuery>;
export type CartItemCountQueryResult = Apollo.QueryResult<CartItemCountQuery, CartItemCountQueryVariables>;
